export default __webpack_public_path__ + "static/media/scroll1.5856cb2a.jpg";